import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar';
import { NewsCard } from '../components/NewsCard';
import { Seo } from '../components/Seo';
import { articles } from '../data/articles';
export function NewsPage() {
  const [featuredArticle, ...remainingArticles] = articles;
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-238" data-mp="20k2qmuuhb8ab">
      <Seo title="News & Updates for Arizona Cities and Towns" description="Read AZ City PAC updates on Arizona local control, municipal leadership, responsible growth, zoning, infrastructure, and stronger communities." path="/news" schema={{
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'AZ City PAC News & Updates',
      description: 'Updates and perspectives on local control, municipal leadership, infrastructure, and Arizona communities.',
      url: 'https://azcitypac.com/news',
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: articles.map((article, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          url: `https://azcitypac.com/news/${article.slug}`,
          name: article.title
        }))
      }
    }} data-id="element-239" data-mp="20ijftjrldpfx" />
      <Navbar data-id="element-240" data-mp="1f4g27yig5g2p" />
      <main className="flex-grow pt-24" data-id="element-241" data-mp="1f4pq9gjxld5r">
        <section className="bg-pac-navy py-16 md:py-24 text-white" data-id="element-242" data-mp="1f60vlkt0ysyz">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243" data-mp="1j5rts9kvsbdj">
            <p className="text-pac-gold font-bold uppercase tracking-[0.2em] text-sm mb-4" data-id="element-244" data-mp="1o4340lf38nwa">
              AZ City PAC
            </p>
            <h1 className="font-serif text-5xl md:text-6xl font-bold mb-5" data-id="element-245" data-mp="1t50k8sgjf7v5">News & Updates</h1>
            <p className="text-xl text-slate-300 max-w-2xl leading-relaxed" data-id="element-246" data-mp="2zizve1yqvp6t">
              Perspectives and updates from Arizona&apos;s statewide coalition for stronger local leadership.
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24" data-id="element-247" data-mp="2ew9y6oreg17q">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248" data-mp="29ucc7mrm6sb3">
            <p className="text-pac-red font-bold uppercase tracking-[0.18em] text-sm mb-5" data-id="element-249" data-mp="2osd0bum93zuo">Featured update</p>
            <NewsCard article={featuredArticle} featured data-id="element-250" data-mp="2jt0i5n6brgyf" />

            <div className="flex items-end justify-between gap-6 mt-20 mb-8 border-b border-slate-200 pb-6" data-id="element-251" data-mp="2jrgwti5tafps">
              <div data-id="element-252" data-mp="1w1mlj5154z7n">
                <h2 className="font-serif text-4xl font-bold text-pac-navy" data-id="element-253" data-mp="1r54iqapdfaxy">From the coalition</h2>
                <p className="text-slate-600 mt-2" data-id="element-254" data-mp="25tipuxttllkb">The latest work and conversations shaping Arizona communities.</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-255" data-mp="211r7haktim59">
              {remainingArticles.map(article => <NewsCard key={article.slug} article={article} data-id="element-256" data-mp="1db50lmmjv7wu" />)}
            </div>

            <div className="mt-16" data-id="element-257" data-mp="18ck5g1m5nef9">
              <Link to="/" className="inline-flex items-center gap-2 text-pac-blue font-bold hover:text-pac-navy transition-colors focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 rounded" data-id="element-258" data-mp="3k1gl00zfhf1v">
                <ArrowLeft className="h-4 w-4" data-id="element-259" data-mp="3a1pusbhwhm7l" />
                Return to AZ City PAC
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-260" data-mp="6nda3dr75709" />
    </div>;
}